/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Offer } from './Offer';
import {
    OfferFromJSON,
    OfferFromJSONTyped,
    OfferToJSON,
    OfferToJSONTyped,
} from './Offer';

/**
 * 
 * @export
 * @interface GroupedAcquisition
 */
export interface GroupedAcquisition {
    /**
     * 
     * @type {number}
     * @memberof GroupedAcquisition
     */
    year: number;
    /**
     * 
     * @type {number}
     * @memberof GroupedAcquisition
     */
    month: number;
    /**
     * 
     * @type {Array<Offer>}
     * @memberof GroupedAcquisition
     */
    offers: Array<Offer>;
}

/**
 * Check if a given object implements the GroupedAcquisition interface.
 */
export function instanceOfGroupedAcquisition(value: object): value is GroupedAcquisition {
    if (!('year' in value) || value['year'] === undefined) return false;
    if (!('month' in value) || value['month'] === undefined) return false;
    if (!('offers' in value) || value['offers'] === undefined) return false;
    return true;
}

export function GroupedAcquisitionFromJSON(json: any): GroupedAcquisition {
    return GroupedAcquisitionFromJSONTyped(json, false);
}

export function GroupedAcquisitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupedAcquisition {
    if (json == null) {
        return json;
    }
    return {
        
        'year': json['year'],
        'month': json['month'],
        'offers': ((json['offers'] as Array<any>).map(OfferFromJSON)),
    };
}

export function GroupedAcquisitionToJSON(json: any): GroupedAcquisition {
    return GroupedAcquisitionToJSONTyped(json, false);
}

export function GroupedAcquisitionToJSONTyped(value?: GroupedAcquisition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'year': value['year'],
        'month': value['month'],
        'offers': ((value['offers'] as Array<any>).map(OfferToJSON)),
    };
}

